
import { Bold, Italic, Underline, List } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

interface FormattingToolbarProps {
  onFormat: (format: string) => void;
}

export const FormattingToolbar = ({ onFormat }: FormattingToolbarProps) => {
  return (
    <ToggleGroup type="multiple" className="justify-start">
      <ToggleGroupItem value="bold" onClick={() => onFormat('bold')}>
        <Bold className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="italic" onClick={() => onFormat('italic')}>
        <Italic className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="underline" onClick={() => onFormat('underline')}>
        <Underline className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="list" onClick={() => onFormat('list')}>
        <List className="h-4 w-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
